import _classCallCheck from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Gain } from "../core/context/Gain";
import { optionsFromArguments } from "../core/util/Defaults";
import { Signal } from "./Signal";
/**
 * Multiply two incoming signals. Or, if a number is given in the constructor,
 * multiplies the incoming signal by that value.
 *
 * @example
 * // multiply two signals
 * const mult = new Tone.Multiply();
 * const sigA = new Tone.Signal(3);
 * const sigB = new Tone.Signal(4);
 * sigA.connect(mult);
 * sigB.connect(mult.factor);
 * // output of mult is 12.
 * @example
 * // multiply a signal and a number
 * const mult = new Tone.Multiply(10);
 * const sig = new Tone.Signal(2).connect(mult);
 * // the output of mult is 20.
 * @category Signal
 */

export var Multiply = /*#__PURE__*/function (_Signal) {
  _inherits(Multiply, _Signal);

  var _super = _createSuper(Multiply);

  function Multiply() {
    var _this;

    _classCallCheck(this, Multiply);

    _this = _super.call(this, Object.assign(optionsFromArguments(Multiply.getDefaults(), arguments, ["value"])));
    _this.name = "Multiply";
    /**
     * Indicates if the value should be overridden on connection
     */

    _this.override = false;
    var options = optionsFromArguments(Multiply.getDefaults(), arguments, ["value"]);
    _this._mult = _this.input = _this.output = new Gain({
      context: _this.context,
      minValue: options.minValue,
      maxValue: options.maxValue
    });
    _this.factor = _this._param = _this._mult.gain;

    _this.factor.setValueAtTime(options.value, 0);

    return _this;
  }

  _createClass(Multiply, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Multiply.prototype), "dispose", this).call(this);

      this._mult.dispose();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(Signal.getDefaults(), {
        value: 0
      });
    }
  }]);

  return Multiply;
}(Signal);